<!--&lt;!&ndash; permission-group.component.html &ndash;&gt;-->
<!--<div class="permission-group" [attr.aria-labelledby]="'group-' + group.id">-->
<!--  &lt;!&ndash; Group checkbox with label &ndash;&gt;-->
<!--  <div class="d-flex align-items-start gap-2 fw-bold">-->
<!--    <input type="checkbox" id="group-checkbox-{{ group.id }}" [checked]="isSelected(group.id)"-->
<!--      (change)="onGroupToggle()" [attr.aria-label]="'Toggle all permissions for ' + group.englishName | lastToken" />-->
<!--    <label class="text-wrap" for="group-checkbox-{{ group.id }}" id="group-{{ group.id }}">-->
<!--      {{ group.englishName | lastToken }}-->
<!--    </label>-->
<!--  </div>-->

<!--  &lt;!&ndash; Permissions within this group &ndash;&gt;-->
<!--  <ul class="permissions-list" *ngIf="group.permissions.length">-->
<!--    <li *ngFor="let permission of group.permissions" class="items-list d-flex align-items-start gap-2">-->
<!--      <input type="checkbox" id="permission-checkbox-{{ permission.id }}" [checked]="isSelected(permission.id)"-->
<!--        (change)="onPermissionToggle(permission)"-->
<!--        [attr.aria-label]="'Permission ' + permission.englishName | lastToken" />-->
<!--      <label class="text-wrap" for="permission-checkbox-{{ permission.id }}">-->
<!--        {{ permission.englishName | lastToken }}-->
<!--      </label>-->
<!--    </li>-->
<!--  </ul>-->

<!--  &lt;!&ndash; Nested Permission Groups &ndash;&gt;-->
<!--  <div class="nested-groups" *ngIf="group.permissionGroups.length">-->
<!--    <app-permission-group *ngFor="let childGroup of group.permissionGroups" [group]="childGroup"-->
<!--      [isSelected]="isSelected" (toggleGroup)="toggleGroup.emit($event)"-->
<!--      (togglePermission)="togglePermission.emit($event)"></app-permission-group>-->
<!--  </div>-->
<!--</div>-->

<h1>Deprecatd Permission Group Componentn</h1>
